import {useState} from 'react'
import CommercialInvoiceForm from './CommercialInvoiceForm';
import CommercialInvoiceList from './CommercialInvoiceList';

const CommercialInvoice = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
  
  return (
    <>
      {fromIsShown ? (
          <CommercialInvoiceForm addForm={setFromIsShown} update={upData} />
        ) : (
          <CommercialInvoiceList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default CommercialInvoice